
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/dialogModal.77d83d616b38.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/dialogModal.77d83d616b38.js";